/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AssignmentIndOutlined,
    BadgeOutlined,
    DatasetOutlined,
    DoorFrontOutlined,
    PointOfSaleOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Reservas from "./Secciones/Seccion_Reservas";
import Seccion_Config_Habitaciones from "./Secciones/Seccion_Config_Habitaciones";
import Seccion_Habitaciones from "./Secciones/Seccion_Habitaciones";
import Seccion_Caja from "./Secciones/Seccion_Caja";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Habitaciones',
        icono: DoorFrontOutlined,
        camino: '/Habitaciones',
        categoria: 'Reservas',
        Componente: <Seccion_Habitaciones/>
    },
    {
        nombre: 'Reservaciones',
        icono: AssignmentIndOutlined,
        camino: '/Reservaciones',
        categoria: 'Reservas',
        Componente: <Seccion_Reservas/>
    },
    {
        nombre: 'Caja',
        icono: PointOfSaleOutlined,
        camino: '/Caja',
        categoria: 'Financiero',
        Componente: <Seccion_Caja/>
    },
    {
        nombre: 'Config. Habitaciones',
        icono: DatasetOutlined,
        camino: '/ConfigHabitaciones',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Config_Habitaciones/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}